export enum CouponType {
  Percentage = "percentage",
  Fixed = "fixed",
}
